import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ApplicationSettingsProvider } from './contexts/ApplicationSettingsContext';
import { AppRouter } from './router';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ApplicationSettingsProvider>
          <AppRouter />
        </ApplicationSettingsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
